<template>
	<Modal
		:visible="visible"
		:confirmLoading="loading"
		:width="500"
		:maskClosable="false"
		title="Привязка продуктов к пользователю"
		okText="Применить"
		cancelText="Отменить"
		centered
		@ok="onLink"
		@cancel="onCancel"
	>
		<template v-if="user">
			<Checkbox v-for="product of products" :key="product.id" :checked="checked[product.id]" @change="onSelect(product, $event)">
				{{ product.name }}
			</Checkbox>
		</template>
	</Modal>
</template>

<script>
import { Checkbox, Modal } from "ant-design-vue"

export default {
	name: "UserTableLinkProducts",
	components: {
		Modal,
		Checkbox
	},
	props: {
		visible: { type: Boolean, required: true },
		user: { type: Object, default: null }
	},
	model: {
		prop: "visible",
		event: "show"
	},
	data() {
		return {
			loading: false,
			products: [],
			checked: {}
		}
	},
	watch: {
		/**
		 * Следить за изменением пользователя
		 */
		user() {
			if (this.user) {
				// Получить карту ID продуктов пользователя
				const userProductIdsMap = this.user.products.reduce((map, product) => {
					map[product.id] = product.status ? true : false

					return map
				}, {})

				this.products.forEach(product => {
					if (userProductIdsMap[product.id]) {
						this.check(product.id)
					} else {
						this.uncheck(product.id)
					}
				})
			}
		}
	},
	methods: {
		/**
		 * Обработать выбор продуктов
		 */
		onSelect(product, { target }) {
			if (target.checked) {
				this.check(product.id)
			} else {
				this.uncheck(product.id)
			}
		},

		/**
		 * Выбрать продукт
		 */
		check(id) {
			this.$set(this.checked, id, true)
		},

		/**
		 * Снять выбор с продукта
		 */
		uncheck(id) {
			this.$set(this.checked, id, false)
		},

		/**
		 * Обработать привязку продуктов
		 */
		onLink() {
			this.$emit("link", { user: this.user, productStatuses: this.checked })
			this.$emit("show", false)
		},

		/**
		 * Обработать отмену
		 */
		onCancel() {
			this.$emit("show", false)
		},

		/**
		 * Получить продукты
		 */
		async getProducts() {
			try {
				this.products = await this.$context.adminProductService.getProducts()
			} catch (message) {
				this.$alert.error(message)
			}
		}
	},
	mounted() {
		this.getProducts()
	}
}
</script>

<style lang="scss" scoped>
</style>
